import { AppAdsTypes } from '../AppAds/AppAds.model';

export const selectTitle = {
	[AppAdsTypes.Realty]: 'Выберите недвижимость',
	[AppAdsTypes.Vehicle]: 'Выберите транспорт',
	[AppAdsTypes.Clothes]: 'Выберите одежду',
	[AppAdsTypes.Other]: 'Выберите товар',
};
